"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const batcher = require("@tanstack/pacer/batcher");
const reactStore = require("@tanstack/react-store");
const PacerProvider = require("../provider/PacerProvider.cjs");
function useBatcher(fn, options = {}, selector = () => ({})) {
  const mergedOptions = {
    ...PacerProvider.useDefaultPacerOptions().batcher,
    ...options
  };
  const [batcher$1] = react.useState(() => new batcher.Batcher(fn, mergedOptions));
  batcher$1.fn = fn;
  batcher$1.setOptions(mergedOptions);
  const state = reactStore.useStore(batcher$1.store, selector);
  return react.useMemo(
    () => ({
      ...batcher$1,
      state
    }),
    // omit `store` in favor of `state`
    [batcher$1, state]
  );
}
exports.useBatcher = useBatcher;
//# sourceMappingURL=useBatcher.cjs.map
